import graphql__9628974077b6dfc22b23 from "./__generated__/ComplexMenuMobileNavigationItem_navigationItem.graphql.js";import { useCallback } from "react";
import classNames from "classnames";
import { useDispatch } from "react-redux";
import { graphql, useFragment } from "react-relay";

import ButtonLink from "../../../Buttons/ButtonLink";
import Collapse from "../../../Utils/Collapse";
import CollapseSwitch from "../../../Utils/CollapseSwitch";
import CollapseContent from "../../../Utils/CollapseContent";
import { useComplexMenuContext, useNavigationItemIsActive } from "../ComplexMenuContext";

import { setBackdropOpen } from "../../../../reducers/styling";
import { useCurrentPathMatchesUrl } from "../../../../helpers/UrlHelper";

const ComplexMenuMobileNavigationItem = props => {
  const navigationItem = useFragment(
    ComplexMenuMobileNavigationItem_navigationItem,
    props.navigationItem
  );
  const { childItems, isTopLevel } = props;
  const { id, name: navigationItemName, isSubMenu, url, iconClass } = navigationItem;

  const hasChildren = childItems?.length > 0;

  const isCollapsibleSubMenu = isTopLevel && isSubMenu && hasChildren;
  const isLink = !isSubMenu && url && url !== "";

  const dispatch = useDispatch();

  const { activeSubMenu } = useComplexMenuContext();
  const {
    isActive: isActiveForMenu,
    handleClick,
    isInitialized
  } = useNavigationItemIsActive(navigationItem);

  const isActiveUrl = useCurrentPathMatchesUrl(url);
  const isActive = isActiveUrl || isActiveForMenu;

  const handleLinkClicked = useCallback(() => {
    handleClick();
    dispatch(setBackdropOpen(false));
  }, [dispatch, handleClick]);

  const handleCollapseExpandedChanged = useCallback(
    isExpanded => {
      if ((!activeSubMenu || id !== activeSubMenu?.id) && isExpanded !== isActive) {
        handleClick();
      }
    },
    [activeSubMenu, handleClick, id, isActive]
  );

  const shouldCollapse = useCallback(() => {
    return !isActive;
  }, [isActive]);

  // If the item is neither a link, neither a collapsible sub menu, we don't render
  // anything as it's not allowed
  if (!isLink && !isCollapsibleSubMenu) return null;

  const iconClassName =
    iconClass &&
    classNames(["text-primary", "text-icon-xl", "margin-right-sm", iconClass]);

  const containerClassName = classNames([
    "header-mobile-dropdown-item-container",
    "text-black",
    {
      "margin-y-sm": isTopLevel,
      "bg-white": isTopLevel
    }
  ]);

  const linkClassName = classNames(
    "header-mobile-navigation-item-button",
    "btn-unstyled",
    "padding-md",
    {
      active: isActive,
      "padding-left-xs": !isTopLevel
    }
  );

  const buttonClassName = classNames(
    "header-mobile-dropdown-item-button",
    "btn",
    "btn-block-md",
    "padding-y-md",
    "d-flex",
    "align-items-center",
    {
      active: isActive,
      "padding-left-xs": !isTopLevel
    }
  );

  return (
    <li className={containerClassName}>
      {/* 
        The `isInitialized` variable allows us to wait for the 
        `useNavigationItemIsActive` hook and ComplexMenuContext hooks to have already run 
        once so the actual current item is known when we first render the collapse, and
        the `expanded` Collapse prop is actually taken into account.
      */}
      {isInitialized && (
        <>
          {isLink && (
            <ButtonLink
              onClick={handleLinkClicked}
              className={linkClassName}
              href={url}
              label={navigationItemName}
              iconClassName={iconClassName}
              iconPosition={null}
            />
          )}

          {isCollapsibleSubMenu && (
            <Collapse
              shouldCollapse={shouldCollapse}
              onExpandedChanged={handleCollapseExpandedChanged}
              expanded={isActive}
            >
              <CollapseSwitch className={buttonClassName} label={navigationItemName} />

              <CollapseContent>
                {hasChildren && (
                  <ul className="list-unstyled">
                    {childItems.map(navigationItem => (
                      <ComplexMenuMobileNavigationItem
                        navigationItem={navigationItem}
                        key={navigationItem.id}
                      />
                    ))}
                  </ul>
                )}
              </CollapseContent>
            </Collapse>
          )}
        </>
      )}
    </li>
  );
};

const ComplexMenuMobileNavigationItem_navigationItem = graphql__9628974077b6dfc22b23;

export default ComplexMenuMobileNavigationItem;
